// export const dateConvert = (date) => {
//   const datetime = new Date(date);
//   // const converDate = new Date(
//   //   Date.UTC(
//   //     datetime.getFullYear(),
//   //     datetime.getMonth(),
//   //     datetime.getDate(),
//   //     datetime.getHours(),
//   //     datetime.getMinutes(),
//   //     datetime.getSeconds()
//   //   )
//   // );
//   const timeString = datetime.toTimeString();
//   const dateString = datetime.toDateString();

//   return `${dateString} ${timeString.split(" ")[0]}`;
// };


export const dateConvert = (date, time) => {
  const datetime = new Date(date);
  const convertDate = new Date(
    Date.UTC(
      datetime.getFullYear(),
      datetime.getMonth(),
      datetime.getDate(),
      datetime.getHours(),
      datetime.getMinutes(),
      datetime.getSeconds()
    )
  );
  const timeString = convertDate.toTimeString();
  // const dateString = convertDate.toLocaleDateString();
  const dateString = ((convertDate.getDate()<=9) ? "0" : "") + convertDate.getDate() + "-" + ((convertDate.getMonth()<=9) ? "0" : "") + (convertDate.getMonth() + 1) + "-" + convertDate.getFullYear();

  if(time){
    return `${dateString} ${timeString.split(" ")[0]}`;
  }
  else{
    return `${dateString}`;
  }
};
